import React, { useEffect, useState } from 'react';
import { LOGO_IMG } from "../../../utills/image-constant";
// import { USERROUTES } from '../../routes/url-constant';
import { useNavigate } from 'react-router-dom';
import { getAllAnswerByEmpId, getAllCampaignByEmployeeId } from '../../../services/api-services';
import { useSelector } from 'react-redux';
import Leftbar from '../comman.js/leftbar';
import ScorePage from './scorePage';
import AdminDataTable from '../../../admin/components/common/AdminDataTable';
import moment from 'moment';
import { USERROUTES } from '../../routes/url-constant';

const UserProfileIntroduction = () => {
  const parsedEmployeeData = useSelector((state) => state?.loggedEmployee?.value);
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [tab, setTab] = useState(1);
  const [campaignList, setCampaignList] = useState([]);
  console.log("campaignList--------------", campaignList);

  const getAllAnswer = async () => {
    try {
      const response = await getAllAnswerByEmpId(parsedEmployeeData?.id, parsedEmployeeData?.isAttempt);
      if (response?.data?.responseCode === 200) {
        setData(response?.data?.responseBody);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const getAllcampaign = async () => {
    try {
      const response = await getAllCampaignByEmployeeId(parsedEmployeeData?.id);
      console.log("response----------------", response?.data);

      if (response?.data?.responseCode === 404) {
        setCampaignList(response?.data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAllcampaign();
    getAllAnswer();
  }, []);

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
  };

  // Get the current date and convert assessment dates
  const now = new Date();
  const currentDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // Convert and remove time for assessmentFrom and assessmentTo
  const assessmentFromDate = new Date(parsedEmployeeData?.assessmentFrom);
  const assessmentToDate = new Date(parsedEmployeeData?.assessmentTo);
  const assessmentFromOnly = new Date(
    assessmentFromDate.getFullYear(),
    assessmentFromDate.getMonth(),
    assessmentFromDate.getDate()
  );

  const assessmentToOnly = new Date(
    assessmentToDate.getFullYear(),
    assessmentToDate.getMonth(),
    assessmentToDate.getDate()
  );

  // If today is before the assessment start date, the link is not open yet
  const linkNotOpenYet = currentDateOnly < assessmentFromOnly;

  // If today is after the assessment end date, the link has expired
  const linkExpired = currentDateOnly > assessmentToOnly;



  const tblColumns = [
    {
      code: "Assessment",
      name: "Assessment",
      width: "150px",
      sortable: false,
      selector: (row) => {
        if (row?.isAssessment === 0) {
          return (
            <button
              className="btn btn-primary nextBtn"
              onClick={() =>
                navigate(USERROUTES?.lATESTPAGE, {
                  state: { Data: row },
                })
              }
            >
              Start
            </button>
          );
        } else if (row?.isAssessment === 1) {
          return (
            <button
              className="btn btn-primary nextBtn"
              onClick={() =>
                navigate(USERROUTES?.lATESTPAGE, {
                  state: { Data: row },
                })
              }
            >
              Continue
            </button>
          );
        } else if (row?.isAssessment === 2) {
          return (
            <button
              className="btn btn-primary nextBtn"
              onClick={() =>
                navigate(USERROUTES?.PREVIEWALLANS, {
                  state: { Data: row, pageType: "Score" },
                })
              }
            >
              Score
            </button>
          );
        } else {
          return null;
        }
      },
    },
    {
      code: "Campaign Name",
      name: "Campaign Name",
      width: "230px",
      sortable: false,
      selector: (row) => (
        <div className="table-cell-content">{row?.campaignName}</div>
      ),
    },
    {
      code: "Model Name",
      name: "Model Name",
      width: "200px",
      sortable: false,
      selector: (row) => (
        <div className="table-cell-content">{row?.modelName}</div>
      ),
    },
    {
      code: "durationFromDate",
      name: "From Date",
      sortable: false,
      selector: (row) => moment(row?.durationFromDate).format("MM/DD/YYYY"),
    },
    {
      code: "durationToDate",
      name: "To Date",
      sortable: false,
      selector: (row) => moment(row?.durationToDate).format("MM/DD/YYYY"),
    },
  ];

  if (!parsedEmployeeData) {
    return <div>Loading...</div>;
  }


  return (
    <div>
      <div className="user_profile_intro">
        <div className="user_data">
          <div className="row">
            <div className="col-md-4">
              <Leftbar pageName="UserTestIntro" />
            </div>
            <div className="col-md-8">
              <div className="user_profile_intro_right">

                <div>
                  <div className="logo-sec">
                    <img src={LOGO_IMG} className="responsive-img logo_img mt-3 mb-3" alt="Logo" />
                  </div>
                  <div className="user-right-content">
                    <div className='d-flex'> <span className="intro_heading" onClick={() => setTab(1)}>Introduction</span>
                      <span className="assessment_heading ms-3" onClick={() => setTab(2)}>Start Assessment</span></div>
                    {
                      tab == 1 ? <>
                        <ul>
                          <li>Please answer with your own vision and understanding of the subject, not from a corporate or marketing posture​.</li>
                          <li>You are not obliged to do the assessment in a single session, you can use your first invitation email to continue any time. Each time a new OTP password will be asked​.​</li>
                          <li>At the end, when you submit your answers, a page will allow you to review your inputs. You can then definitely submit it or correct your anwsers</li>
                          <li>After this final submission, no change will be  possible​.​</li>
                          <li>You need to anwser a maximum of questions, you are not obliged to answer all questions.</li>
                          <li>If you have a technical problem or do not understand a question, please refer to your core team representative. ​</li>
                        </ul>
                      </> : <>

                        <AdminDataTable
                          _tblColumns={tblColumns}
                          _rowData={campaignList}
                          tableCustomStyles={tableCustomStyles}
                          // _totalRows={totalElement}
                          pending={false}
                          pagination={false}
                        // setPending={setPending}
                        // pageSize={pageSize}
                        // setPageSize={setPageSize}
                        // setPage={setPage}
                        // totalElement={totalElement}
                        // setSortColumn={setSortColumn}
                        // setSortDirection={setSortDirection}
                        />


                      </>
                    }



                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>


  );
};

export default UserProfileIntroduction;
